import React from 'react';
import Icon from '@common/assets';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const UpdateButton = ({ onClick, disabled }: { onClick: () => void; disabled: boolean }) => {
  return (
    <button className={cx('btn')} type="button" disabled={disabled} onClick={onClick}>
      <Icon name="guideLight" width={24} height={24} />
      편집
    </button>
  );
};

export default UpdateButton;
